import SidePanelHeader from "../components/SidePanelHeader"
import { useNavigate } from "react-router"
import * as Navigation from "../../../../../modules/Navigation";
import SidePanelInfo from "../components/SidePanelInfo"

export default function SidePanelDisposalLineItem({ data, onViewPage }: any) {
    const navigate = useNavigate();

    return (<>
        {data &&
            <>
                {!onViewPage && <SidePanelHeader descriptor={"Packing Box"} value={data.reference} statuses={data.status} onClick={undefined} />}
                <SidePanelInfo
                    values={[
                        { label: "Notes", value: data.notes },
                    ]}
                />
            </>
        }
    </>)
}